module.exports = "<div class=\"tooltip\">\r\n  ? <span class=\"tooltiptext\"> {{ this.Skeleton.Label }} </span>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/s-tooltip/s-tooltip.component.html
// module id = ./src/app/shared/components/s-tooltip/s-tooltip.component.html
// module chunks = main